import { useSearchParams } from 'react-router-dom'
import { isEmpty, toBoolean } from '@/resources/utils'
import { TypeMap, GenericFilterType } from './types'
import { ARRAY_SEPARATOR, ParamTypes } from './constants'

interface UrlFiltersProps {
  typeMap: TypeMap
}

export const useUrlFilters = <T extends GenericFilterType>({
  typeMap,
}: UrlFiltersProps) => {
  const [searchParams] = useSearchParams()

  const getUrlFilters = (): T => {
    return getDecodedFilters<T>(searchParams, typeMap)
  }

  return getUrlFilters
}

const getDecodedFilters = <T extends GenericFilterType>(
  searchParams: URLSearchParams,
  typeMap: TypeMap
) => {
  const urlFilters: T = Object.assign({})

  for (const [key, value] of searchParams.entries()) {
    urlFilters[key as keyof T] = getParsedValue(decodeURI(value), typeMap[key])
  }

  return urlFilters
}

const getParsedValue = (value: string, type: ParamTypes) => {
  if (isEmpty(value) || isEmpty(type)) return undefined

  switch (type) {
    case ParamTypes.OBJECT:
      return JSON.parse(value)
    case ParamTypes.ARRAY:
      return value.split(ARRAY_SEPARATOR)
    case ParamTypes.BOOLEAN:
      return toBoolean(value)
    case ParamTypes.NUMBER:
      return !isNaN(parseInt(value)) ? parseInt(value) : undefined
    default:
      return value
  }
}
